import {useEffect} from "react";

export const FinalizarAutoAgendamiento = ({data}) => {
    useEffect(() => {
        const event = new CustomEvent("formDataAppointment", {detail: data});

        window.dispatchEvent(event);

        console.log("Evento formDataAppointment enviado", data);
    }, []);

    return (
        <div className="card-dinamic">
            <p>
                Sr (a). Usuario: Gracias por agendar su cita con nosotros. Recibirá la
                confirmación en la brevedad posible mediante mensaje de texto y correo
                electrónico (verifique la bandeja de correo no deseado)
            </p>
        </div>
    );
};
